import { mapState } from 'vuex';
import iconsMixin from '../dtwin/state/bridge/iconsMixin';
import get from 'lodash/get';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/mode/markdown/markdown.js';
export default {
  name: 'CoreDeviceTemplateEditTemplateInformation',
  components: {
    MarkdownItVueLight
  },
  mixins: [iconsMixin],
  props: {
    template: {
      type: Object,
      required: true
    },
    account: {
      type: String,
      default: null
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    },
    readonly: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data: function () {
    return {
      markdownEdit: false,
      formValid: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    scopeDetailledName() {
      const name = get(this.template, 'scope.name');
      const id = get(this.template, 'scope.id') || get(this.template, 'scopeId');
      if (id !== undefined) {
        return `${name} (ID ${id})`;
      }
      return name;
    }
  },
  watch: {
    template: {
      handler() {
        if (!this.template) {
          return;
        }
        this.$emit('formValidated', this.formValid);
      },
      deep: true
    },
    formValid() {
      this.$emit('formValidated', this.formValid);
    }
  },
  methods: {
    get,
    parentSelectorFilter(item, parentList) {
      return item.tenantId === this.template.tenantId && item.id !== this.template.id && parentList.findIndex(t => t.id === this.template.id) === -1;
    }
  }
};